'use client'
import React from 'react';
import styled from "styled-components";
import {Img} from "@/components/Img";
import {hover, light, medium, text, Transition} from "@/styles/globalStyleVars";
import Link from "next/link";


const MediaBox = ({src, data,type,date,title,img,keyword}) => {


    return (
        <StyledComponent className=''>
            <Link href={`/news-events/${src}`} >
                    <div className='presslist__single' >
                        <div className='presslist__single__img'>
                            <Img src={img}/>
                        </div>
                        <div className='presslist__single__content'>
                            <h5>{title}</h5>
                            <div className='presslist__single__content__text'/>
                            <div className='presslist__single__content__link'>
                                {
                                    type && keyword === null &&
                                    type?.map((e,index) => {
                                        return (
                                            <>
                                                <p>{e?.name}</p>
                                                <span className={'dot'}/>
                                            </>
                                        )
                                    })
                                }


                                {
                                    keyword!=null &&
                                    type?.length > 0 &&
                                    type?.map((e, index) => {
                                        if (keyword === e?.slug) {
                                            return (
                                                <React.Fragment key={index}>
                                                    <p>{e?.name}</p>
                                                    <span className={'dot'} />
                                                </React.Fragment>
                                            );
                                        }
                                        return null; // Don't return anything for non-matching items
                                    })
                                }


                                <p>{date}</p>
                            </div>

                        </div>
                    </div>
            </Link>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    cursor: pointer;
    background-color: #FFFFFF;
    .presslist {
        &__single {
            margin-bottom: 30px;
            //box-sizing: border-box;
            transition: 1s ease-in-out;
            -webkit-transition: all 0.2s ease-in-out;
            border: 1px solid transparent;
            height: 100%;

            &:hover {
                //outline: auto;
                //outline-color:  #EE1B24;
                transition: 1s ease-in-out;
                -webkit-transition: all 0.2s ease-in-out;
                //box-shadow: 0 5px 30px rgba(238, 27, 36, 0.08);
                border-radius: unset;

            }

            &__img {
                position: relative;
                padding-top: calc(200 / 370 * 100%);
                overflow: hidden;

                .global-image {
                    overflow: hidden;

                    img {
                        transform: scale(1.01);
                        transition: 0.7s all ${Transition};
                    }
                }

                &:hover {
                    .global-image img {
                        transform: scale(1.06) !important;
                    }
                }

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                }

            }

            &__content {
                position: relative;
                padding: 30px 30px 25px;
                background-color: #FFFFFF;
                height: 100%;
                @media (max-width: 992px) {
                    font-size: 18px;
                    line-height: 27px;
                };

                h5 {
                    font-weight: 500 !important;
                    font-family: ${medium};
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #131719;
                    min-height: 60px;

                    &:hover {
                        color: ${hover};
                    }
                }

                &__text {
                    min-height: 70px;
                }

                &__link {
                    position: absolute;
                    bottom: 25px;
                    display: flex;
                    align-items: center;

                    p {
                        font-size: 12px;
                        line-height: normal;
                        font-family: ${light};
                        font-weight: 300;
                        color: ${text};
                    }

                    .dot {
                        width: 6px;
                        height: 6px;
                        background-color: ${text};
                        border-radius: 50%;
                        z-index: 9999999;
                        margin: 0px 10px;
                    }
                }

                h2 {

                    margin-bottom: 20px;
                    color: #FB030C;
                    font-weight: 500;
                }


                &__learn {
                    position: relative;

                    &:after {
                        content: '';
                        height: 3px;
                        width: 0px;
                        background-image: linear-gradient(#AD0000, #FF0000);
                        position: absolute;
                        transition: .3s;
                    }

                    h2 {
                        color: #222222;
                        font-weight: 500;
                        cursor: pointer;
                        border-bottom: 2px solid #222222;
                        width: 26%;
                    }
                }

            }

            @media (max-width: 767px) {
                margin-bottom: 20px !important;
                :last-child {
                    margin-bottom: 0px;
                }
            }

        }
    }
`;

export default React.memo(MediaBox);
